module.exports = __webpack_public_path__ + "img/login-bg.a8e377a2.jpg";